import { ExamCheckboxSection } from "../InitialPsychotherapy/InitialPsychotherapyConstant";

// The DAP note reuses the checkbox-card storage shape used by the MSE /
// Psychiatric Evaluation modals: every section persists its selection as a
// comma-separated string of option names, e.g.
// { interventionsProvided: "supportiveTherapy,dbtSkills" }, plus a `${key}Note`
// free text.

// Option name that reveals the "Other Therapeutic Interventions" free text.
export const OTHER_THERAPEUTIC_INTERVENTIONS = "otherTherapeuticInterventions";

// Key the "Other Therapeutic Interventions" free text is persisted under.
export const OTHER_INTERVENTIONS_NOTE_KEY = "otherTherapeuticInterventionsNote";

export const DAP_INTERVENTIONS_SECTIONS: ExamCheckboxSection[] = [
  {
    key: "interventionsProvided",
    label: "Interventions Provided",
    items: [
      { name: "supportiveTherapy", label: "Supportive Therapy" },
      { name: "cbtTechniques", label: "CBT Techniques" },
      { name: "dbtSkills", label: "DBT Skills" },
      { name: "motivationalInterviewing", label: "Motivational Interviewing" },
      { name: "psychoeducation", label: "Psychoeducation" },
      { name: "mindfulnessExercises", label: "Mindfulness Exercises" },
      { name: "crisisIntervention", label: "Crisis Intervention" },
      { name: "medicationEducation", label: "Medication Education" },
      { name: "safetyPlanning", label: "Safety Planning" },
      {
        name: OTHER_THERAPEUTIC_INTERVENTIONS,
        label: "Other Therapeutic Interventions",
      },
    ],
  },
];

export const DAP_PATIENT_RESPONSE_SECTIONS: ExamCheckboxSection[] = [
  {
    key: "patientResponse",
    label: "Patient Response",
    items: [
      { name: "engaged", label: "Engaged" },
      { name: "cooperative", label: "Cooperative" },
      { name: "receptive", label: "Receptive" },
      { name: "resistant", label: "Resistant" },
      { name: "emotionalResponse", label: "Emotional Response" },
      {
        name: "demonstratedUnderstanding",
        label: "Demonstrated Understanding",
      },
      { name: "participatedInExercises", label: "Participated in Exercises" },
      { name: "completedHomeworkReview", label: "Completed Homework Review" },
    ],
  },
];

// Fields each modal owns — passed to useFormDraft so edits only reach the note
// on Save, exactly like the MSE modal.
const sectionFields = (sections: ExamCheckboxSection[]) =>
  sections.flatMap((section) => [
    section.key,
    section.noteKey ?? `${section.key}Note`,
  ]);

export const DAP_INTERVENTIONS_FIELDS = [
  ...sectionFields(DAP_INTERVENTIONS_SECTIONS),
  OTHER_INTERVENTIONS_NOTE_KEY,
];

export const DAP_PATIENT_RESPONSE_FIELDS = sectionFields(
  DAP_PATIENT_RESPONSE_SECTIONS
);
